//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';

export default {
  props: {
    data: { type: Object, required: true },
  },

  data() {
    return {
      loader: false,
      loaderTelegramCheckboxes: true,
      emailNotificationTypeList: [],
      telegramNotificationTypeList: [],
      telegramId: '',
      constant,
    };
  },

  computed: {
    ...mapState('login', ['currentAdmin']),
    ...mapState('adminManagementAdmins', ['adminNotificationsSettings']),

    statusList: () => constant.admin.ADMIN_STATUS_LIST,
    adminNotificationTypeList: () => constant.admin.ADMIN_NOTIFICATION_TYPE_LIST,

    currentAdminNotificationsSettings() {
      const { data, adminNotificationsSettings } = this;
      return adminNotificationsSettings.filter((e) => e.adminId === data.id);
    },

    currentAdminTelegramId: {
      get() {
        const { currentAdminNotificationsSettings } = this;
        if (currentAdminNotificationsSettings) {
          return this.getCurrentNotificationsByType('telegram').telegramId || null;
        }

        return '';
      },
      set(telegramId) {
        this.telegramId = telegramId;
      },
    },
  },

  watch: {
    telegramId(value) {
      this.loaderTelegramCheckboxes = true;
      if (value.length) this.loaderTelegramCheckboxes = false;
    },
  },

  created() {
    const { currentAdminNotificationsSettings } = this;
    if (currentAdminNotificationsSettings) {
      this.telegramNotificationTypeList = this.getCurrentNotificationsByType('telegram').adminNotificationTypeList || [];
      this.emailNotificationTypeList = this.getCurrentNotificationsByType('email').adminNotificationTypeList || [];
    }

    if (this.currentAdminTelegramId !== null) {
      this.loaderTelegramCheckboxes = false;
    }
  },

  methods: {
    ...mapActions('common', [
      'confirmAction',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('adminManagementAdmins', {
      changeAdminStatusAction: 'changeAdminStatus',
      loadAdminManagementAdmins: 'loadData',
      blockAdminAction: 'blockAdmin',
      unblockAdminAction: 'unblockAdmin',
      loadAdminNotificationsSettings: 'loadAdminNotificationsSettings',
      removeAdminNotificationsSettingsAction: 'removeAdminNotificationsSettings',
      addAdminNotificationsSettingsAction: 'addAdminNotificationsSettings',
      editAdminNotificationsSettingsAction: 'editAdminNotificationsSettings',
    }),

    getCurrentNotificationsByType(type) {
      const { currentAdminNotificationsSettings } = this;
      if (type === 'telegram') return currentAdminNotificationsSettings.find((e) => e.telegramId !== null) || [];
      if (type === 'email') return currentAdminNotificationsSettings.find((e) => e.email !== null) || [];

      return null;
    },

    confirmChangeStatus(value) {
      const { id } = this.data;
      this.confirmAction({
        text: 'Are you sure you want to change status?',
        callback: async () => {
          this.loader = true;
          this.setGeneralProgress(true);

          await this.changeAdminStatusAction({
            AdminId: id,
            Status: value,
          });
          await this.loadAdminManagementAdmins();

          this.setSuccessNotification('Status successfully changed');
          this.loader = false;
          this.setGeneralProgress(false);
        },
      });
    },

    confirmBlockAdmin() {
      const { id } = this.data;
      const currentId = this.currentAdmin.id;
      if (id === currentId) {
        this.setErrorNotification('You cannot block yourself');
        return;
      }
      this.confirmAction({
        text: 'Are you sure you want to block admin?',
        callback: async () => {
          this.loader = true;
          this.setGeneralProgress(true);

          await this.blockAdminAction(id);
          await this.loadAdminManagementAdmins();

          this.setSuccessNotification('Admin blocked');
          this.loader = false;
          this.setGeneralProgress(false);
        },
      });
    },

    async confirmUnblockAdmin() {
      const { id } = this.data;
      this.loader = true;
      this.setGeneralProgress(true);

      await this.unblockAdminAction(id);
      await this.loadAdminManagementAdmins();

      this.setSuccessNotification('Admin unblocked');
      this.loader = false;
      this.setGeneralProgress(false);
    },

    async removeNotificationsForCurrentAdmin(type) {
      this.loader = true;
      const { id } = this.getCurrentNotificationsByType(type);
      await this.removeAdminNotificationsSettingsAction({ id });
      await this.loadAdminManagementAdmins();
      await this.loadAdminNotificationsSettings();
      this.telegramNotificationTypeList = this.getCurrentNotificationsByType('telegram').adminNotificationTypeList || [];
      this.emailNotificationTypeList = this.getCurrentNotificationsByType('email').adminNotificationTypeList || [];
      this.loader = false;
      this.setSuccessNotification('Notifications settings changed');
    },
    async applyNotificationsSettings(type) {
      const { emailNotificationTypeList, telegramNotificationTypeList, telegramId } = this;
      const { email } = this.data;
      this.loader = true;
      this.setGeneralProgress(true);
      const requestData = {
        userName: email,
        language: 'En',
        adminNotificationTypeList: type === 'email' ? emailNotificationTypeList : telegramNotificationTypeList,
      };
      try {
        if (this.getCurrentNotificationsByType(type).adminNotificationTypeList) {
          await this.editAdminNotificationsSettingsAction({
            id: this.getCurrentNotificationsByType(type).id,
            ...requestData,
          });
        } else {
          await this.addAdminNotificationsSettingsAction({
            adminId: this.data.id,
            ...(type === 'email' ? { email } : { telegramId }),
            ...requestData,
          });
        }
        await this.loadAdminNotificationsSettings();
        this.loader = false;
        this.setGeneralProgress(false);
        this.setSuccessNotification('Notifications settings changed');
      } catch (error) {
        this.loader = false;
        this.setGeneralProgress(false);
        this.setErrorNotification(error.message);
      }
    },
  },
};
